export function inputNumberValidate(text: string): boolean {
    if (text === null) {
        return false;
    }

    // 00* - is not valid
    if (text.length >= 2 && text.substr(0, 2) === '00') {
        return false;
    }

    if (text === '.') {
        return true;
    }

    const decimalCount = text.includes('.') && text.split('.')[1].length || 0;

    if (decimalCount > 2) {
        return false;
    }

    // we cannot have '-' or ' '
    if (text.includes('-') || text.includes(' ')) {
        return false;
    }

    // Max amount of signs in field equals 12.
    if (text.length > 12) {
        return false;
    }

    return !isNaN(text as any);
}
